const state = {
  bankTips:
    '温馨提示：请不要添加有收款限额的银行卡号（如：部分银行卡有每日收款额度限额1万，年收款限额20万），避免大额收款时，因限额导致收款失败',
};
export default {
  namespaced: true,
  state,
};
